/*jshint esversion: 6 */
/*jshint strict:false */

import axios from "axios";
import TomSelect from "tom-select";

class Modal {
    constructor(node, overlay) {
        this.node = node;
        this.overlay = overlay;
        this.content = node.querySelector('.modalwin_content');
        this.title = node.querySelector('.modalwin_title');
        this.close = node.querySelector('.modalwin_close');
        this.href = "";

        this.close.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
        })

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' || e.key === 'Esc') {
                this.hide();
            }
        })
    }

    show() {
        this.node.classList.add('modalwin--show');

    }

    hide() {
        this.node.classList.remove('modalwin--show');
        this.overlay.classList.remove('overlay--show');
        this.unload();
    }

    unload() {
        this.content.innerHTML = "";
        this.href = "";
    }

    initForm() {
        this.form = this.content.querySelector('form');

        const selects = this.content.querySelectorAll('select');
        [...selects].forEach(select => {
            new TomSelect(select, {
                copyClassesToDropdown: false,
            });
        })

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const data = new FormData(this.form);
            data.set("BackURL", this.href);

            // WARNING: Does not work on :3000

            const buttons = this.form.querySelectorAll('input[type="submit"]');
            [...buttons].forEach((button) => {
                button.value = "Wird gesendet...";
                button.disabled = true;
            })

            axios({
                method: 'post',
                url: this.form.action,
                data: data,
                config: { headers: {
                    'Content-Type': 'multipart/form-data',
                }}
            })
            .then((response) => {
                //handle success
                // console.log(response);
                const data = response.data;

                if(data === "RELOAD") {
                    window.location.reload();
                } else {
                    if(data.startsWith("REDIRECT")) {
                        window.location.href = data.replace("REDIRECT:", "");
                    } else {
                        this.content.innerHTML = response.data;
                        this.initForm();
                    }
                }
            })
            .catch(function (response) {
                //handle error
                console.log(response);
            });
        })
    }

    load(href, title) {
        this.overlay.classList.add('overlay--show');
        this.href = href;

        axios.get(href)
            .then((response) => {
                this.content.innerHTML = response.data;
                this.title.innerHTML = title;
                this.initForm();
                this.show();
            })
    }
}

export default Modal;
